<template>
  <base-form
    v-model="formData"
    :options="options"
    labelWidth="100px"
    :disabled="!canEdit"
    :maxLabelLength="7"
    @input="handleChange"
    ref="formData"
  ></base-form>
</template>

<script>
  import { mapState } from 'vuex';
  import baseForm from '@/components/form/base-form';
  import DataBaseAPI from '@/api/dataBase';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import API from '@/api/wareHouse/costAdjustOrder';
  // import searchTable from '@/components/form-item/search-table';
  import XEUtils from 'xe-utils';
  export default {
    name: 'baseData',
    props: ['baseData', 'companyList', 'query', 'canEdit'],
    components: {
      baseForm,
      // ajaxSelect,
      // searchTable,
    },
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        departmentList: [], // 部门列表
        editConfig: {},
        formData: {
          docNo: null, // 单据编号
          docStatus: '',
          storageCompanyCode: null, // 公司代码
          storageCompanyName: null, // 公司名称
          storageDepartmentCode: null, // 部门代码
          storageDepartmentName: null, // 部门名称
          gmtCreate: date, //调整日期
          accountingStatus: null, //入账状态
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //顶部表单配置
      options() {
        const data = this.formData;
        return [
          {
            //申请单公司代码
            prop: 'storageCompanyCode',
            type: 'select',
            label: this.$t('costAdjustOrderList.column.companyName'),
            options: this.companyList,
            clearable: true,
            required: true,
            currentValue: data.storageCompanyCode,
          },
          {
            //申请单部门代码
            prop: 'storageDepartmentCode',
            type: 'select',
            label: this.$t('costAdjustOrderList.column.departmentName'),
            options: this.departmentList,
            clearable: true,
            disabled: false,
            required: true,
            currentValue: data.storageDepartmentCode,
          },
          {
            //调整日期
            prop: 'gmtCreate',
            type: 'date',
            label: this.$t('costAdjustOrderList.column.gmtCreate'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            // 单据编号
            prop: 'docNo',
            type: 'input',
            label: this.$t('costAdjustOrderList.column.docNo'),
            placeholder: this.$t('costAdjustOrderList.placeholder.docNoPlaceholder'),
            // clearable: false,
            disabled: true,
          },
          {
            //单据状态
            prop: 'docStatus',
            type: 'dict',
            label: this.$t('costAdjustOrderList.column.docStatus'),
            dictType: 'cost_adjust_order_status',
            placeholder: this.$t('costAdjustOrderList.placeholder.docNoPlaceholder'),
            disabled: true,
          },
          {
            //入账状态
            prop: 'accountingStatus',
            label: this.$t('costAdjustOrderList.column.accountingStatus'),
            type: 'dict',
            dictType: 'post_status',
            clearable: true,
            disabled: true,
          },
        ];
      },
    },
    watch: {
      // 监听表单变化
      formData: {
        handler: XEUtils.debounce(function () {
          this.$emit('updateForm', this.formData);
        }, 100),
        deep: true,
      },
    },
    mounted() {
      // this.getdepartmentList(this.formData.storageCompanyCode);
    },
    methods: {
      handleChange(v, prop) {
        this.formData[prop] = v[prop];
        if (prop == 'storageCompanyCode') {
          //公司编码
          this.formData.storageCompanyCode = v[prop];
          this.formData.storageDepartmentCode = '';
          this.formData.departmentName = '';
          this.$emit('resetRowInfo');
          if (!v[prop]) return;
          this.formData.storageCompanyName = this.companyList.find(
            (it) => it.value == v[prop]
          ).label;
          this.getdepartmentList(this.formData.storageCompanyCode);
        } else if (prop == 'departmentCode') {
          //部门编码
          this.formData.departmentCode = v[prop];
          this.formData.departmentName = this.departmentList.find(
            (it) => it.value == v[prop]
          ).label;
        }
      },
      // 获取部门
      getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
    },
  };
</script>
